import React, { useEffect, useState, createContext, useContext } from "react";
import Header from "../Header";
// import { Contract, EventDetails, PressPack, Submit, Travel, Promoter, } from "../promoter"
import { Box, Stepper, Step, StepLabel, Button } from "@mui/material";
import Contract from "./Contract";
import EventDetails from "./Event";
import PressPack from "./PressPack";
import Submit from "./Submit";
import Travel from "./Travel"
import Promoter from "./Promoter"
import InvoiceReview from "./InvoiceReview";
import { AppContext } from "../../App";

const steps = [
  'Event details',
  'Promoter Details',
  'Travel Details',
  'Contract Review',
  'Invoice Review',
  'Presspack and Downloads',
  'Upload and Submit'
]

export default function PromoterMain(){

  const [activeSection, setActiveSection] = useState(0)

  const { eventDetails, artistInfo, setArtistInfo } = useContext(AppContext)

  const pageUp = () => {
    if(activeSection === steps.length -1) return;
    else {setActiveSection(currentSection => currentSection + 1)}
  }

  const pageDown = () => {
    if(activeSection === 0) return;
    else {setActiveSection(currentSection => currentSection - 1)}    
  }

  async function updateEventOnDB(e){
    e.preventDefault()
    const id = eventDetails.eventID

    await fetch(`https://the-paper-pusher.herokuapp.com/updateEvent/${id}`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(eventDetails)
    })
  }

  async function getArtistInfo(){
    const response = await fetch(`https://the-paper-pusher.herokuapp.com/checkLogin/${eventDetails.artistUsername}`)
    if (!response.ok) {
      const message = `An error occurred: ${response.statusText}`
      window.alert(message)
      return
    }

    const artistInfo = await response.json()
    setArtistInfo(artistInfo)
  }

  useEffect(()=>{
    getArtistInfo()
  },[])

  return (
      <div>
        <div className="main-container">
          <Header />
            <h4 className="booking-title">
              Thank you for booking {eventDetails.bandName}!
            </h4>
            <h6 className="more-details-title">
              Please provide us with the information below so we can proceed with the booking.
            </h6>
            {/* <Box sx={{ width: '100%', marginBottom: '1em' }}>
              <Stepper activeStep={activeSection} alternativeLabel>
                {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
                ))}
              </Stepper>
            </Box> */}
            {activeSection === 0 ? <EventDetails></EventDetails> : (
              activeSection === 1 ? <Promoter></Promoter>: (
                activeSection === 2 ? <Travel></Travel> : (
                  activeSection === 3 ? <Contract /> : (
                    activeSection === 4 ? <InvoiceReview /> : (
                      activeSection === 5 ? <PressPack/> : (
                        activeSection === 6 ? <Submit /> : null
                    )
                  )
                )
              )
            )
          )
          }
            <div className='back-next-btns'>
              <Button disabled={activeSection === 0 ? true : false} onClick={pageDown}>Back</Button>
              <Button disabled={activeSection === 6 ? true : false} onClick={pageUp}>Next</Button>
            </div>
            {activeSection === 6 
            ? <Button variant="outlined" size="large" onClick={updateEventOnDB}>Save & Submit</Button>
            : null
            }
            
            
          </div>
      </div>
  )
}